module.exports = __webpack_public_path__ + "static/media/Project Monitoring Group Brochure.39f4c288.pdf";